import React from 'react'

import Paper from 'app/components/base/Paper'
import SignUpBusinessFeature from 'app/features/Auth/SignUpBusinessFeature'
import GoogleReCaptchaV3Provider from 'app/providers/GoogleRecaptchaV3Provider'

import AuthContainer from '~/components/layouts/AuthContainer'

const SignUpBusinessView: RFC = () => {
  return (
    <AuthContainer>
      <Paper sx={{ px: { xs: 2, md: 6.7 } }}>
        <GoogleReCaptchaV3Provider>
          <SignUpBusinessFeature />
        </GoogleReCaptchaV3Provider>
      </Paper>
    </AuthContainer>
  )
}

export default SignUpBusinessView
